import React from 'react'

const data = [
  {
    img: "/assets/images/about-office-1.webp",
    title: "Ahmedabad",
    desc: "Warehouse No. 15, Survey No. 405/1P, Plot-A, Behind Changodar City Center, Under Changodar Bridge",
  },
  {
    img: "/assets/images/about-office-2.webp",
    title: "Bangalore",
    desc: "55/1, Block 2 & 3, Heggadevapura Village Alur Road, Alur Post, Dasanpura Hobli",
  },
  {
    img: "/assets/images/about-office-3.webp",
    title: "Bhiwandi",
    desc: "Unit Nos. 5, 6, 7, 8, 9, 10 And 11, Building B-4, Green Space, Mumbai-Nasik Highway, Village Vahuli, Taluka Bhiwandi, Dist. Thane",
  },
  {
    img: "/assets/images/about-office-4.webp",
    title: "Chennai",
    desc: "Indospace AS Industrial Park No. 104, Shed No. B-600 Chatiram Village, Polivakkam, Thiruvallar, Sriperumbudur Road, Thiruvallar",
  },
  {
    img: "/assets/images/about-office-5.webp",
    title: "New Delhi",
    desc: "Plot No. NO-146, Pole No-152, Vill-Bamnoli, Backside Portion, Najafgarh Near PP No. 152, Pochanpur Road",
  },
  {
    img: "/assets/images/about-office-6.webp",
    title: "Gurgaon 1",
    desc: "Khasra Number 1233/1349, Mustil No. 159, Village Badshahpur, Sohna Road, Sector 68",
  },
  {
    img: "/assets/images/about-office-7.webp",
    title: "Gurgaon 2",
    desc: "Killa No. 242/18, 23/1, Village Bhondsi, Sohna Road",
  },
  {
    img: "/assets/images/about-office-8.webp",
    title: "Tauru-Bilaspur",
    desc: "Khata No. 381 And 383 And 134 And 412, Warehouse Facing Sports Stadium Jhumawas Bilaspur Tauru Road, Village Guddhi, Tehsil Tauru",
  },
  {
    img: "/assets/images/about-office-9.webp",
    title: "Hyderabad",
    desc: "Devar Yamjal, Opp Sai Geetha Ashramam, Sy No. 705/2, 706/4, House 8-400001, Tumkunta Municipality, Medchal Malkajgiri",
  },
  {
    img: "/assets/images/about-office-10.webp",
    title: "Hyderabad",
    desc: "Sy. No. 721, 42E, 48E, 41E, Devaryamjal Village, Shamirpet Mandal, Medchal Dist., Medchal",
  },
  {
    img: "/assets/images/about-office-11.webp",
    title: "Kolkata",
    desc: "Plot No. D3-49/1, Banirpool (Dak Ghar), Budge-Budge Trunk Road (BBT Road), Maheshtala",
  },
  {
    img: "/assets/images/about-office-12.webp",
    title: "Lucknow",
    desc: "Khasra No. 1517, Rushtam Vihar, Nadarganj Industrial Area, Near Cipet College",
  },
  {
    img: "/assets/images/about-office-13.webp",
    title: "Mumbai",
    desc: "Dashmesh Complex & Godowns, Plot #105, 106, At & Post Nadhal, Taluka Khalapur, Dist. Raigad",
  },
  {
    img: "/assets/images/about-office-14.webp",
    title: "Pune",
    desc: "Gate No. 354, Behind General Motors Material Gate, Umbrae Navalakh",
  },
  {
    img: "/assets/images/about-office-15.webp",
    title: "Zirakpur",
    desc: "Ground Floor, Warehouse No. B014/3433, Near Vivekanand School, Village Pabhat, Thana, Tehsil Dera Bassi, District SAS Nagar",
  },
  {
    img: "/assets/images/about-office-16.webp",
    title: "Zirakpur",
    desc: "Village Pabhat Road Godown Area, Zirakpur, Khewat No. 702, Khatauni No. 725, Sub Tehsil Zirakpur, Tehsil Dera Bassi, Vill. Pabhat, Dist. Mohali, Punjab",
  },
  {
    img: "/assets/images/about-office-17.webp",
    title: "Guwahati",
    desc: "Gopal Than Parking, Near Zudio Shopping Mall, Lokhra, Guwahati, District Kamrup Metro",
  },
  {
    img: "/assets/images/about-office-18.webp",
    title: "Andheri",
    desc: "Unit No. 3, Kanchan Ind. Premises Co-Op Soc. Ltd., Sakinaka Telephone Exchange Road, Kurla Andheri Road",
  },
  {
    img: "/assets/images/about-office-19.webp",
    title: "Siliguri",
    desc: "Mirik Road, Plot No. 5, Khatian No. 1587, J.L. No. 56, Baniakhari, Tripali Jote, P.O. Nmai, P.S. Matigara, Dist. Darjeeling, Pin-734010",
  },
  {
    img: "/assets/images/about-office-20.webp",
    title: "Jalandhar",
    desc: "Village Khajurla, Kot Kalan, Jalandhar, Punjab",
  },
  {
    img: "/assets/images/about-office-21.webp",
    title: "Bilaspur",
    desc: "House No. 198/1, Baloh, Lakhanpur Distt.",
  },
  {
    img: "/assets/images/about-office-22.webp",
    title: "Goa",
    desc: "Plot No. Sy No. 147/1, Plot A, Mushir Wado, Colvale, Bardez, Goa, Mapusa B",
  },
  {
    img: "/assets/images/about-office-23.webp",
    title: "Indore",
    desc: "Khasra No. 103/3, 18/2, Lasudia Mori, A.B. Road",
  },
  {
    img: "/assets/images/about-office-24.webp",
    title: "Jaipur",
    desc: "Drop: Plot No. 11/IB/4, Mahapura, Ring Road, Bagru",
  },
  {
    img: "/assets/images/about-office-25.webp",
    title: "Dehradun",
    desc: "SR-12 & SR-13, Transport Nagar Phase-1",
  },
  {
    img: "/assets/images/about-office-26.webp",
    title: "Noida",
    desc: "Ridku, 582-K Chhapraula, G.B. Nagar, Dadri",
  },
  {
    img: "/assets/images/about-office-27.webp",
    title: "Bhubaneswar",
    desc: "Plot No-121/1277/2265, Khata No. 253/100, Kantabada",
  }
]



export default function AboutOffice() {
  return (
    <>
      <section className="about-office-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h3 className="heading center-heading">Our Offices</h3>
              <p className="sub-heading">Dox and Box began its journey in New Delhi and is now headquartered in Gurugram, India. Our widespread presence enables us to deliver efficient document management and digitization services to enterprises wherever they operate.</p>
            </div>

            <div className="col-lg-12">
              <div className="about-office-boxes">
                <div className="row">
                  {data?.map((item, index) => (
                    <div key={index} className="col-lg-4 col-md-6">
                      <div className="about-office-box">
                        <img src={item?.img} alt="Goal Box" />
                        <span>{item?.title}</span>
                        <p>{item?.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
